
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/terms",
      function () {
        return require("private-next-pages/[slug]/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/terms"])
      });
    }
  